import { DefaultError, useQuery } from '@tanstack/react-query';
import { apiClient } from 'utils';
import { useResponseHandler } from 'utils/service/responseHandler';
import { ITrackLight } from './types';

export const useGetTrackLightList = (enabled = true) => {
  const { responseHandler } = useResponseHandler();
  return useQuery<ITrackLight[], DefaultError>({
    queryKey: ['track-light-list'],
    async queryFn() {
      const response = await apiClient({
        method: 'GET',
        url: `Track/LightList`,
      });

      return responseHandler(response, {
        groupName: `useGetTrackLightList`,
      });
    },
    enabled,
  });
};
